module.exports = __webpack_public_path__ + "img/minigoldenmixfront.b664f7b0.jpg";